module.exports = __webpack_public_path__ + "static/media/Angel.b995f211.jpg";